import dayjs, { Dayjs } from 'dayjs';
import pluralize from 'pluralize-ru';

import { DAYS_IN_WEEK } from '../constants/date';

export const getCurrentYear = () => dayjs().year();

const nbsp = '\u00A0';
export const convertDateToFriendlyFormat = (date: Dayjs) => date.format(`D${nbsp}MMMM${nbsp}HH:mm`);

export const getDiffInDays = (dateFrom: Dayjs, dateTo: Dayjs) => {
  const doubleDiffInDays = dateTo.diff(dateFrom, 'days', true);
  return Math.round(doubleDiffInDays);
};

export const getPluralizedDiffInDays = (dateFrom: Dayjs, dateTo: Dayjs) => {
  const diffInDays = getDiffInDays(dateFrom, dateTo);
  if (diffInDays === 0) {
    return '';
  }
  const DAYS_PLURALS = [`%d${nbsp}день`, `%d${nbsp}дня`, `%d${nbsp}дней`];
  return pluralize(diffInDays, '', ...DAYS_PLURALS);
};

export const getIsDateInInterval = ({
  dateFrom,
  dateTo,
  date,
}: {
  dateFrom: Dayjs;
  dateTo: Dayjs;
  date: Dayjs;
}) => {
  return dateTo.isAfter(date) && dateFrom.isBefore(date);
};

export const getDay = (date: Dayjs) => date.date();
export const getWeekDay = (date: Dayjs) => date.weekday();

export const getCalendarFirstDate = (dateFrom: Dayjs) => {
  const daysFromFirstWeekStart = getWeekDay(dateFrom);
  return dateFrom.subtract(daysFromFirstWeekStart, 'days');
};

export const getCalendarLastDate = (dateTo: Dayjs) => {
  const daysFromLastWeekStart = getWeekDay(dateTo);
  const maxDiffToWeekEnd = DAYS_IN_WEEK - 1;
  const daysToLastWeekEnd = maxDiffToWeekEnd - daysFromLastWeekStart;
  return dateTo.add(daysToLastWeekEnd, 'days');
};

export const getWeeksCount = (dateFrom: Dayjs, dateTo: Dayjs) => {
  const doubleWeeks = dateTo.diff(dateFrom, 'weeks', true);
  return Math.ceil(doubleWeeks);
};

export const getWeekStartDate = (dateFrom: Dayjs, week: number) => {
  return dateFrom.add(week, 'weeks');
};

export const getWeekDateByStartDate = (startDate: Dayjs, day: number) => {
  return startDate.add(day, 'days');
};
